// har Spin par naya id
export const newRequestId = () => crypto.randomUUID();

// server ke winningNumber ("36", "00") ko wheel ke format me badlo
export const toWheelNumber = (winningNumber) =>
  winningNumber === "00" ? "00" : Number(winningNumber);

// Board ke keys ko API ke bets me badlo
export const buildBets = (bets) =>
  Object.entries(bets).map(([key, amount]) => {
    if (key.startsWith("n:"))
      return { type: "number", value: key.slice(2), amount };
    if (key.startsWith("col:"))
      return { type: "column", value: key.slice(4), amount };
    if (key.startsWith("doz:"))
      return { type: "dozen", value: key.slice(4), amount };
    if (key === "red" || key === "black")
      return { type: "color", value: key, amount };
    if (key === "even" || key === "odd")
      return { type: "evenodd", value: key, amount };
    if (key === "low" || key === "high")
      return { type: "highlow", value: key, amount };
    throw new Error(`Unknown bet key: ${key}`);
  });
